/* ORJN: make the concierge chat launcher look AI-powered.
   The widget (external app) renders <button id="orjn-launcher"> as a dark square
   with a plain chat bubble. We swap the icon for a lime AI "sparkle" and add a
   small "AI" badge — without touching the app's behavior (click still opens it).
   Re-applies if the widget re-renders. */
(function () {
  'use strict';

  var ACCENT = '#c6ff2e';

  // Lime AI "sparkle" icon (two stars) — signals AI assistant.
  var SPARKLE_SVG =
    '<svg class="orjn-ai-spark" width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">' +
      '<path fill="' + ACCENT + '" d="M13 2l1.8 4.9L19.7 8.7l-4.9 1.8L13 15.4l-1.8-4.9L6.3 8.7l4.9-1.8L13 2z"/>' +
      '<path fill="' + ACCENT + '" opacity="0.85" d="M5.5 13.5l.9 2.5 2.5.9-2.5.9-.9 2.5-.9-2.5L2 16.9l2.6-.9.9-2.5z"/>' +
    '</svg>';

  function injectStyles() {
    if (document.getElementById('orjn-ai-launcher-styles')) return;
    var s = document.createElement('style');
    s.id = 'orjn-ai-launcher-styles';
    s.textContent =
      '#orjn-launcher{position:relative;overflow:visible !important;}' +
      /* hide the app's original chat-bubble svg (the direct child svg we did not add) */
      '#orjn-launcher > svg:not(.orjn-ai-spark){display:none !important;}' +
      '#orjn-launcher .orjn-ai-spark{display:block;filter:drop-shadow(0 0 6px rgba(198,255,46,0.45));}' +
      /* "AI" badge */
      '#orjn-launcher .orjn-ai-badge{position:absolute;top:-7px;right:-7px;background:' + ACCENT + ';color:#050505;' +
        'font-family:Inter,sans-serif;font-weight:900;font-size:10px;letter-spacing:0.06em;line-height:1;' +
        'padding:3px 5px;border-radius:2px;box-shadow:0 2px 8px rgba(0,0,0,0.45);pointer-events:none;}' +
      /* subtle lime ring so the square reads as active/AI */
      '#orjn-launcher{box-shadow:0 0 0 1px rgba(198,255,46,0.55), 0 10px 30px rgba(0,0,0,0.5) !important;}';
    document.head.appendChild(s);
  }

  function decorate() {
    var btn = document.getElementById('orjn-launcher');
    if (!btn || btn.dataset.orjnAi) return;
    btn.dataset.orjnAi = '1';
    injectStyles();
    // add sparkle (keep original svg in DOM but hidden via CSS, so app logic is intact)
    btn.insertAdjacentHTML('beforeend', SPARKLE_SVG);
    // add AI badge
    var badge = document.createElement('span');
    badge.className = 'orjn-ai-badge';
    badge.textContent = 'AI';
    btn.appendChild(badge);
    if (!btn.getAttribute('aria-label') || /concierge/i.test(btn.getAttribute('aria-label'))) {
      btn.setAttribute('aria-label', 'Ask ORJN AI');
    }
  }

  // run now + keep watching (widget loads async / may re-render)
  function start() {
    decorate();
    var tries = 0;
    var iv = setInterval(function () {
      decorate();
      if (document.getElementById('orjn-launcher') && document.querySelector('#orjn-launcher .orjn-ai-spark')) {
        // decorated; slow the interval but keep a light watcher for re-renders
      }
      if (++tries > 40) clearInterval(iv); // ~20s of polling then stop
    }, 500);
    // also react to DOM changes (re-render)
    try {
      new MutationObserver(function () { decorate(); }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
